import { Link } from "react-router-dom";

const Inner = ({ text }) => {
  const render = (key) =>
    text.split("*").map((seg, i) =>
      i % 2 === 1 ? (
        <em key={`${key}-${i}`} className="font-serif italic normal-case tracking-normal text-[1.25em]">
          {seg}
        </em>
      ) : (
        <span key={`${key}-${i}`}>{seg}</span>
      )
    );
  return (
    <span className="vero-btn-wrap">
      <span className="vero-btn-text">{render("a")}</span>
      <span className="vero-btn-copy" aria-hidden="true">{render("b")}</span>
    </span>
  );
};

export const VeroButton = ({ text, to, onClick, testId, className = "" }) => {
  if (to)
    return (
      <Link to={to} data-testid={testId} className={`vero-btn ${className}`}>
        <Inner text={text} />
      </Link>
    );
  return (
    <button onClick={onClick} data-testid={testId} className={`vero-btn ${className}`}>
      <Inner text={text} />
    </button>
  );
};
